import React from 'react'
import './AddOrRemoveFavouriteBox.css'

const AddOrRemoveFavouriteBox = ({children, heartColor}) => {
    return (
        <div className="fav-icon" style={{color: heartColor}}>
            {children}
        </div>
    )
}

export default AddOrRemoveFavouriteBox
